import {
  AdminExamCenterDetailsPermissionRoute,
  ExamCenterDetails,
} from '@exam-center/admin-exam-center-details';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { useParams } from '@exam-center/router';
import { WithPermission } from '@shared/permissions';

export default function AdminExamCenterDetailsPage() {
  const { examCenterCode } = useParams('/admin/exam-centers/:examCenterCode/details');
  return (
    <WithPermission
      requiredPermission={APP_PERMISSIONS.ADMIN_EXAM_CENTER_MANAGEMENT.EXAM_CENTER.VIEW}
      errorElement={AdminExamCenterDetailsPermissionRoute}
      slotProps={{ errorElement: { examCenterCode } }}
    >
      <ExamCenterDetails />
    </WithPermission>
  );
}
